import "./style.scss"

let VueMaximizable = {};

VueMaximizable.install = function (Vue, options) {
  Vue.directive('maximizable', {
    bind (el, binding, vnode, oldVnode) {
      const btn = document.createElement('div');
      btn.classList.add('a-maximizable-btn');

      vnode.elm.insertBefore(btn, vnode.elm.childNodes[0]);
      vnode.elm.classList.add('a-maximizable');

      btn.addEventListener('click', function () {
        vnode.elm.classList.toggle('a-full-screen-block');
      }.bind(this));
    },

    inserted (el, binding, vnode, oldVnode) {
    }
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueMaximizable)
}
export default VueMaximizable;
